import { Col, Row, Typography } from "antd";
import data from "./data.json";

const NumbersSection = () => {
  return (
    <section className="numbers-section">
      <div className="container">
        <Row>
          {data.map((item, index) => (
            <Col xs={24} sm={12} md={8} key={item?.title}>
              <Number {...item} isFirst={index === 0} />
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

const Number = ({ title, text, isFirst }) => (
  <div className={`number ${isFirst ? "first" : ""}`}>
    <Typography.Title>{title}</Typography.Title>
    <Typography.Paragraph className="font-20 number-desc">
      {text}
    </Typography.Paragraph>
  </div>
);

export default NumbersSection;
